import React, {useState, useEffect} from "react";
import { Eye, EyeOff, Mail, Lock, Key, Home, ArrowLeft } from "lucide-react";
import {WebLink, SiteWide, Images} from "./customComponents";
import {useNavigate} from 'react-router-dom';

import {authActions} from '../redux/actions';
import Helper1, {notify} from '../utility/Helper1';
import  APIRequests from '../utility/APIRequests';
import Countdown from 'react-countdown';
import { userSelect, allRemoteSettingsSelect } from '../redux/selectors/index';

import { useSelector, useDispatch } from 'react-redux';

function ForgetPassword(){
    const [emailInput, setEmailInput] = useState('') 
    const [newPassword, setNewPassword] = useState('') 
    const [confirmNewPassword, setConfirmNewPassword] = useState('') 
    const [emailCode, setEmailCode] = useState('')
    const [requestOTPRetObj, setRequestOTPRetObj] = useState({})
    const [uiLevel, setUiLevel] = useState(0)
    const [fullPageLoading, setFullPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [focusedField, setFocusedField] = useState(null);

    const site_settings = useSelector(allRemoteSettingsSelect);
    const navigate = useNavigate();

    const handleInputFocus = (field) => {
        setFocusedField(field);
    };

    const handleInputBlur = () => {
        setFocusedField(null);
    };


    const requestOTP = async (e) => {
        
        e.preventDefault();
        setLoading(true);
        setFullPageLoading(true);

        let loadApi = new APIRequests;
        let getPost = await loadApi.runPost("account/reset_password_pin", {email: emailInput});

        if(getPost?.code == 1){
            setUiLevel(1)
            setRequestOTPRetObj(getPost?.data)
        }

        notify(getPost?.msg, getPost?.code)
        setLoading(false);
        setFullPageLoading(false);

    }


   

    const changePassword = async (e) => {

        e.preventDefault();

        if((newPassword != confirmNewPassword) || (newPassword == '')){
            notify("Passwords must match", 0)
            return;
        }

        
        setLoading(true);
        setFullPageLoading(true);

        let loadApi = new APIRequests;
        let getPost = await loadApi.runPost("account/reset_password", {email: emailInput, password:newPassword, passwordResetCode:emailCode});

        if(getPost?.code == 1){
            setUiLevel(0)
            notify("Password reset successful. You are being redirected to login page", 1)
            
            setTimeout(() => {
                navigate('/signin');
            }, 5000)
        }

        // notify(getPost?.msg, getPost?.code)
        setLoading(false);
        setFullPageLoading(false);


    }

    return (
        <SiteWide>
            <div style={{backgroundColor: `#233950`}} className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden bg-dark">
                {/* Animated background elements */}
                <div className="absolute inset-0 opacity-20">
                    <div className="absolute top-20 left-20 w-72 h-72 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
                    <div className="absolute top-40 right-20 w-72 h-72 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
                    <div className="absolute -bottom-8 left-40 w-72 h-72 bg-gradient-to-r from-green-500 to-cyan-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-500"></div>
                </div>

                {/* Floating particles */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-2 h-2 bg-white rounded-full opacity-20 animate-bounce"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 2}s`,
                                animationDuration: `${2 + Math.random() * 2}s`
                            }}
                        ></div>
                    ))}
                </div>

                {/* Main reset password container */}
                <div className="relative z-10 w-full max-w-md">
                    {/* Glowing border effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 rounded-2xl blur-sm opacity-75 animate-pulse"></div>

                    <div className="relative bg-gray-900/80 backdrop-blur-xl rounded-2xl p-8 shadow-2xl border border-gray-700/50">
                        {/* Header */}
                        <div className="text-center mb-8">
                            <div className="relative inline-block">
                                <Images
                                    height="60px"
                                    src={site_settings?.site_settings?.logo || "/api/placeholder/200/60"}
                                    alt="logo"
                                    className="mx-auto mb-4 filter brightness-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-purple-500 rounded-lg blur-lg opacity-30"></div>
                            </div>
                            <h2 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent mb-2">
                                Reset Password
                            </h2>
                            <p className="text-gray-400 text-sm">
                                {uiLevel === 0 ? 'Enter your email to receive reset code' : 'Enter new password and verification code'}
                            </p>
                        </div>

                        {/* Step 1: Email Input */}
                        {uiLevel === 0 && (
                            <form className="space-y-6">
                                <div className="relative group">
                                    <label className="block text-sm font-medium text-gray-300 mb-2">
                                        Email Address
                                    </label>
                                    <div className="relative">
                                        <div className={`absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'email' ? 'opacity-100' : 'opacity-0'}`}></div>
                                        <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                        <input
                                            type="email"
                                            value={emailInput}
                                            onChange={(e) => setEmailInput(e.target.value)}
                                            onFocus={() => handleInputFocus('email')}
                                            onBlur={handleInputBlur}
                                            placeholder="Enter your email address"
                                            className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                            required
                                        />
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={requestOTP}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    className="relative w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden group"
                                >
                                    {/* Button background gradient */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 transition-opacity duration-300"></div>
                                    <div className={`absolute inset-0 bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}></div>

                                    {/* Button glow effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>

                                    <div className="relative flex items-center justify-center space-x-2">
                                        {loading ? (
                                            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                        ) : (
                                            <>
                                                <Key className="w-5 h-5" />
                                                <span>Send Reset Code</span>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </form>
                        )}

                        {/* Step 2: Password Reset */}
                        {uiLevel === 1 && (
                            <form className="space-y-6">
                                <div className="relative group">
                                    <label className="block text-sm font-medium text-gray-300 mb-2">
                                        New Password
                                    </label>
                                    <div className="relative">
                                        <div className={`absolute inset-0 bg-gradient-to-r from-green-500/20 to-cyan-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'newPassword' ? 'opacity-100' : 'opacity-0'}`}></div>
                                        <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                        <input
                                            type="password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            onFocus={() => handleInputFocus('newPassword')}
                                            onBlur={handleInputBlur}
                                            placeholder="Enter new password"
                                            className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="relative group">
                                    <label className="block text-sm font-medium text-gray-300 mb-2">
                                        Confirm New Password
                                    </label>
                                    <div className="relative">
                                        <div className={`absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'confirmPassword' ? 'opacity-100' : 'opacity-0'}`}></div>
                                        <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                        <input
                                            type="password"
                                            value={confirmNewPassword}
                                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                                            onFocus={() => handleInputFocus('confirmPassword')}
                                            onBlur={handleInputBlur}
                                            placeholder="Confirm new password"
                                            className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="relative group">
                                    <label className="block text-sm font-medium text-gray-300 mb-2">
                                        Verification Code
                                    </label>
                                    <div className="relative">
                                        <div className={`absolute inset-0 bg-gradient-to-r from-orange-500/20 to-red-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'code' ? 'opacity-100' : 'opacity-0'}`}></div>
                                        <Key className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                        <input
                                            type="text"
                                            value={emailCode}
                                            onChange={(e) => setEmailCode(e.target.value)}
                                            onFocus={() => handleInputFocus('code')}
                                            onBlur={handleInputBlur}
                                            placeholder="Enter verification code"
                                            className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Countdown Timer */}
                                <div className="text-center">
                                    <div className="text-sm text-gray-400">
                                        <Countdown
                                            zeroPadTime={2}
                                            key={new Date(requestOTPRetObj?.passwordResetCodeTimer)}
                                            date={new Date(requestOTPRetObj?.passwordResetCodeTimer)}
                                            renderer={({ hours, minutes, seconds, completed }) => {
                                                if (completed) {
                                                    return <span className="text-red-400">Code expired. Please request a new one.</span>
                                                } else {
                                                    return <span>Code expires in {minutes}:{seconds}</span>;
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={changePassword}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    className="relative w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden group"
                                >
                                    {/* Button background gradient */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 transition-opacity duration-300"></div>
                                    <div className={`absolute inset-0 bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}></div>

                                    {/* Button glow effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>

                                    <div className="relative flex items-center justify-center space-x-2">
                                        {loading ? (
                                            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                        ) : (
                                            <>
                                                <Lock className="w-5 h-5" />
                                                <span>Reset Password</span>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </form>
                        )}

                        {/* Links */}
                        <div className="flex flex-col space-y-3 pt-6">
                            <div className="flex justify-center items-center text-sm">
                                <WebLink
                                    to="/signin"
                                    className="text-cyan-400 hover:text-cyan-300 transition-colors duration-200 hover:underline flex items-center space-x-2"
                                >
                                    <ArrowLeft className="w-4 h-4" />
                                    <span>Back to Sign In</span>
                                </WebLink>
                            </div>
                        </div>

                        {/* Decorative elements */}
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 rounded-t-2xl"></div>
                    </div>
                </div>

                {/* Bottom navigation icons */}
                <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-20">
                    <div className="flex space-x-6 bg-gray-900/70 backdrop-blur-lg px-6 py-3 rounded-full border border-gray-700/50">
                        {[
                            { icon: Home, to: '/', color: 'text-cyan-400' },
                        ].map(({ icon: Icon, color, to }, index) => (
                            <button
                                onClick={() => navigate(to)}
                                key={index}
                                className={`${color} hover:scale-110 transition-transform duration-200 p-2 rounded-full hover:bg-white/10`}
                            >
                                <Icon className="w-5 h-5" />
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </SiteWide>
    );

}

export default ForgetPassword;